document.addEventListener('cart:itemsAdded', (event) => {
  const { items, source } = event.detail;
  if (source !== 'product-page') return; // ✅ пропускаем всё, что не из основной формы
  window.lastAddedItems = Array.isArray(items) ? items : [items];
  window.lastAddedSource = source;
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this._observer = new MutationObserver(() => this._markNewItemsAfterPaint());
    this._attachObserver();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    window.cartShipping();

    this._markNewItemsAfterPaint();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this._attachObserver();
    this._markNewItemsAfterPaint();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  _attachObserver() {
    const inner = this.querySelector('.drawer__inner');
    if (!inner || !this._observer) return;
    this._observer.disconnect();
    this._observer.observe(inner, { childList: true, subtree: true });
  }

  _markNewItemsAfterPaint() {
    if (window.lastAddedSource === 'accessory') return;
    if (!['product-page', 'bundle'].includes(window.lastAddedSource)) return;
    if (!window.lastAddedItems || !window.lastAddedItems.length) return;

    const items = window.lastAddedItems;
    const total = items.length;
    let markedCount = 0;

    items.forEach((item, index) => {
      const node = document.querySelector(`#CartDrawer-Item-${item.id}`);
      if (node) {
        node.classList.add('is-new');
        const orderValue = index;
        node.style.order = orderValue;
        markedCount++;
      }
    });

    const hasNewItems = markedCount > 0 || this._hasAnyNewItems();

    if (!hasNewItems) {
      this.close();
    }
  }

  _hasAnyNewItems() {
    return !!this.querySelector(
      '[id^="CartDrawer-Item-"].is-new, .cart-item-wrapper.is-new, .cart-item.is-new'
    );
  }

}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);